
/**
 * The UserWay Accessibility Menu. Loaded on multiple pages to ensure ada compliance.
 * This includes both the script to attach the widget and the custom trigger to open it.
 * More information can be found here: https://userway.org, https://userway.org/tutorials/product-guides/custom-trigger/, https://userway.org/docs.
 */
 import React from 'react';

 import { ReactComponent as AccessibilityIcon } from '../Assets/Icons/AccessibilityIcon.svg';
 
 export const UserWayAccessibilityMenu = ({
   color,
   height,
   top,
   left,
   transparent,
 }) => {
   const hasPosition = left || top;
   return (
    <>
      <button
        id="UserWayAccessibilityMenu"
        style={{
          position: hasPosition && "absolute",
          backgroundColor: transparent && "transparent",
          color: color,
          border: "none",
          zIndex: 1001,
          top: "80px",
          left: "calc(100% - 50px)",
          cursor: "pointer",
        }}
        onClick={() => {
            if (typeof window.UserWay?.widgetToggle === "function") {
              window.UserWay.widgetToggle();
            } else {
              console.warn("UserWay accessibility widget is not ready.");
            }
        }}
      >
        <AccessibilityIcon height={height} width={height} />
      </button>
    </>
   );
 };